import showSidePane from './showSidePane';
import { addChat } from '../actions/ucmaActions';
import { addPresenceSubscription } from '../presenceManager/presenceSubscription';
import acceptChatSession from '../services/acceptChatSession';
import ChatViewState, { ChatRecipient } from '../store/schema/ChatViewState';
import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import {
    lazyAddNotification,
    ensureNotificationHandlerRegistered,
    NotificationActionType,
    NotificationViewState,
} from 'owa-header-toast-notification';

export default function startChat(imAddress: string) {
    const chat = createChatViewState(-1 /*sessionId*/, [
        {
            sipUri: imAddress,
            displayName: imAddress, // TODO: 46635. Get DisplayName for the person
        },
    ]);

    onAddNewChat(chat);
}

export function addChatNotification(notification: InstantMessagePayload) {
    ensureNotificationHandlerRegistered(
        NotificationActionType.SkypeForBusinessNotification,
        onClickNotification
    );

    const viewState = createChatViewState(notification.ChatSessionId, [
        {
            displayName: notification.DisplayName,
            sipUri: notification.SipUri,
        },
    ]);

    lazyAddNotification.importAndExecute({
        actionType: NotificationActionType.SkypeForBusinessNotification,
        title: notification.DisplayName,
        description: notification.ToastMessage,
        actionContext: viewState,
    } as NotificationViewState);
}

function onClickNotification(notification: NotificationViewState) {
    const chat = notification.actionContext as ChatViewState;
    acceptChatSession(chat.sessionId);
    onAddNewChat(chat);
}

function createChatViewState(sessionId: number, recipients: ChatRecipient[]): ChatViewState {
    return {
        sessionId,
        recipients,
        messages: [],
        pendingMessage: '',
        lastMessageSequence: 0,
    };
}

function onAddNewChat(chat: ChatViewState) {
    addPresenceSubscription(chat.recipients);
    addChat(chat);
    showSidePane();
}
